<template>
  <div class="product-details-content-register-module-customization">
    <div class="my-6">
      <step-title
        title="Personalização"
        description="Defina como será a cara do módulo para seus alunos."
        icon="fa-solid fa-pen-ruler"
        fa
      />
    </div>

    <tab-cover :form="form" :errors="errors" />

    <div class="row">
      <div class="col-lg-10 py-3">
        <hr />
        <div class="my-3 fs-14 pt-5">
          <span>Cartaz vertical</span>
        </div>
        <div class="card-box p-5 mb-9">
          <div class="row p-5 mb-5 mt-6 ml-0">
            <input-image
              id="imagem-vertical"
              v-model="form.picture"
              title="Cartaz vertical"
              description="Esta imagem será exibida na tela inicial."
              dimensions="440x632px"
              class="pt-5 col-md-6"
            />
            <picture-mockup
              :image="form.picture"
              class="pt-6 pt-md-5 col-md-6"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TabCover from "@/components/product/details/content/customize/TabCover.vue";
import PictureMockup from "@/components/product/member-area/module/PictureMockup";

export default {
  components: {
    PictureMockup,
    TabCover
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.product-details-content-register-module-customization {
  .card-box {
    height: fit-content;
  }
  span {
    color: #2b2733;
    font-size: 14px;
  }
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
